import templateUrl from './edit-product-order-status.component.html';

export const EditProductOrderStatusComponent = {
    templateUrl,
    require: {
        form: "^^?form"
    },
    bindings: {
        productOrder: "<",
        productOrderStatuses: "<",
        onDeleteProductOrderStatus : "&"
    },
    controller: class {

        $onInit() {
        }

        deleteProductOrderStatus(status) {
            this.onDeleteProductOrderStatus({
                $event: {
                    status
                }
            });
        }
    }
}
